import type { DropzoneOptions } from 'react-dropzone';

export const DOCUMENT_AUTHORIZED_FORMATS: Record<string, string[]> = {
  'application/pdf': ['.pdf'],
  'image/jpeg': ['.jpg', '.jpeg'],
  'image/png': ['.png'],
  'image/heic': ['.heic'],
};

export const fileExtension = (name: string) => {
  const dot = name.lastIndexOf('.');
  return dot > 0 ? name.slice(dot).toLowerCase() : name;
};

export const acceptedExtensionsOf = (accept: DropzoneOptions['accept']) =>
  Object.values(accept ?? {})
    .flat()
    .map(extension => extension.toLowerCase());

export const findUnsupportedFile = <TFile extends { name: string }>(
  files: TFile[],
  extensions: string[],
) =>
  extensions.length === 0
    ? undefined
    : files.find(({ name }) => !extensions.includes(fileExtension(name)));

export const formatList = (extensions: string[]) =>
  extensions.map(extension => extension.replace('.', '').toUpperCase()).join(', ');
